// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__1GW1r","wrapper":"styles_wrapper__3spsj","option":"styles_option__3YeAx","formText":"styles_formText__3wToz"};